import React from 'react';

import ModalUI from './Modal';

const Modal = (props) => {
    return <ModalUI { ...props } />
}

export default Modal;